
import $ from 'jquery';
import * as Core from 'Util/core';
import { publish } from 'Util/pubsub';

let $nav;
let selectors;
let classes;

let navHeight;
let $anchorLinks;
let $navWithMenus;
let $closeButton;

let NavLarge = {
	init: function($elm, selectorList, classList) {
		NavLarge = this;
		$nav = $elm;
		selectors = selectorList;
		classes = classList;

		NavLarge._initElements();
		NavLarge._setSizes();
		NavLarge._initSubscriptions();
		NavLarge._initEvents();
	},

	_setSizes: function() {
		navHeight = $nav.outerHeight();
//		navPos = $nav.offset().top;
	},

	_initElements: function () {
		//$window = $(window);
		//$body = $('body');
		$navWithMenus = $nav.find(selectors.navItemMega);
		$anchorLinks = $('.js-anchor-link');
		$closeButton = $('.js-megamenu-close');
	},

	// Listen for window resize event (listener bound on all.js)
	_initSubscriptions: function () {
		//subscribe('/window/resize', NavLarge._setSizes);
	},

	_initEvents: function() {
		$anchorLinks.on('click', NavLarge._processAnchorClick);
		$closeButton.on('click', NavLarge._closeMenu);

		this._bindClickEvents();
	},

	_toggleMegaMenu: function (target, click, event) {

		if (click === 'click') {
			event.preventDefault();
		}

		const $thisTarget = $(target);
		const $item = $thisTarget.closest('[aria-expanded]');
		const $siblings = $item.siblings('[aria-expanded="true"]');

		if (click && click === 'click' && $item.attr('aria-expanded') !== 'true') {
			$siblings.attr('aria-expanded', false);
			$siblings.addClass(classes.allowAnimations);

			// Close any nested expanded items in siblings
			$siblings.find('[aria-expanded="true"]').attr('aria-expanded', false);
		}

		if ($item.attr('aria-expanded') === 'true') {
			$item.attr('aria-expanded', false);
			$item.addClass(classes.allowAnimations);

			// Close any nested expanded items within this item when closing
			$item.find('[aria-expanded="true"]').attr('aria-expanded', false);
		} else {
			$item.attr('aria-expanded', true);
			$item.addClass(classes.allowAnimations);
		}

	},

	unbind: function () {
		$anchorLinks.off('click', NavLarge._processAnchorClick);
		$navWithMenus.off('click', this._toggleMegaMenu);
		$navWithMenus.off('mouseenter').off('mouseleave');
		$navWithMenus.removeProp('hoverIntent_t');
		$navWithMenus.removeProp('hoverIntent_s');

		this._unbindClickEvents();
	},

	_toggleMegaMenuClick: function(event) {
		publish('/nav/navToggle');
		NavLarge._toggleMegaMenu(this, 'click', event);
	},

	_processAnchorClick: function(event) {
		event.preventDefault();

		const hash = this.href.split('#')[1];
		const $anchor = $('#' + hash);

		if ($anchor.length) {
			Core.scrollToElm($anchor, navHeight -1);
		}
	},

	_bindClickEvents: function() {
		$navWithMenus.each(function() {
			$(this).find(selectors.megamenuHeading).on('click', NavLarge._toggleMegaMenuClick);
			$(this).find(selectors.megamenuSubheading).on('click', NavLarge._toggleMegaMenuClick);
		});
		$('body').on('click', NavLarge._handleBodyClick);
	},

	_unbindClickEvents: function() {
		$navWithMenus.each(function() {
			$(this).find(selectors.megamenuHeading).off('click', NavLarge._toggleMegaMenuClick);
			$(this).find(selectors.megamenuSubheading).off('click', NavLarge._toggleMegaMenuClick);
		});
		$('body').off('click', NavLarge._handleBodyClick);
	},

	_closeMenu: function() {
		const $expandedItem = $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]');
		if ($expandedItem.length) {
			// Close any nested expanded items (including subheading parents)
			$expandedItem.find('[aria-expanded="true"]').attr('aria-expanded', false);

			// Then close the main menu item
			$expandedItem.attr('aria-expanded', false);
			$expandedItem.addClass(classes.allowAnimations);
		}
	},

	_handleBodyClick: function(e) {
		const $target = $(e.target);
		let $expandedItem;

		if (!$target.closest(selectors.nav).length && $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]').length) {
			$expandedItem = $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]');

			// Close any nested expanded items (including subheading parents)
			$expandedItem.find('[aria-expanded="true"]').attr('aria-expanded', false);

			// Then close the main menu item
			$expandedItem.attr('aria-expanded', false);
			$expandedItem.addClass(classes.allowAnimations);
		}
	}
};

export { NavLarge };
